export default {
  dashboard: state => state.dashboard
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/getters.js